export default __webpack_public_path__ + "static/media/bg-slider3.af3e23fb.jpg";